import {Col, Form, Row} from "react-bootstrap";
import {ModalDialog} from "../modal/ModalDialog.js";
import React from "react";
import {APIClient} from "../../core/utils/APIClient.js";
import useForm from "../../core/hooks/useForm.js";
import {fetchPromises} from "../../core/utils/fetchPromises.js";

function BrandModal({setModal, brand, refreshBrands}) {
    const {form, onInputChange} = useForm({
        ...brand,
    });

    const onModalSaveClick = async () => {
        try {
            await APIClient().saveBrand(form);
            refreshBrands();
        } catch (e) {
            console.log(e);
        }
    }

    const onModalClose = () => {
        setModal({
            show: false
        });
    }

    return (
        <ModalDialog show onClose={onModalClose} onCallback={onModalSaveClick} title="Brand">
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4">
                    Name
                </Form.Label>
                <Col sm="8">
                    <Form.Control type="text" name="name" onChange={onInputChange} value={form.name || ''} required />
                    <Form.Control.Feedback type="invalid">
                        Field is required.
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
        </ModalDialog>
    );
}

export default fetchPromises({
    brand: (props) => props.brandId && ({ name: 'getBrand', props: ['brandId'] }),
}, false)(BrandModal);
